import { render, staticRenderFns } from "./ConfirmEventUpdateDialog.vue?vue&type=template&id=e409a65c&scoped=true"
import script from "./ConfirmEventUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmEventUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e409a65c",
  null
  
)

export default component.exports